import { Box, Button, Stack, Typography } from '@mui/material'
import { UIItemContentContainer, UIShadowContainer } from 'features/UI'

interface OrganizationSearchResultItemProps {
  id: number
  name: string
  onTipClick: (tipId: number) => void
}

const boxSX = {
  display: 'inline-block',
  paddingX: 1,
  paddingY: 0.5,
  borderRadius: 1,
  background: '#4CAF50',
  alignSelf: 'flex-end',
  color: 'white',
}

export const OrganizationSearchResultItem = (props: OrganizationSearchResultItemProps) => {
  const { name, id, onTipClick } = props

  const onClick = () => {
    onTipClick(id)
  }

  return (
    <UIShadowContainer sx={{ height: '100%' }}>
      <UIItemContentContainer spacing={2} justifyContent="space-between" onClick={onClick}>
        <Typography fontWeight={400} variant="h6" className="text-max-lines-3">
          {name}
        </Typography>
        <Stack spacing={1.5} alignItems="flex-end">
          <Box sx={boxSX}>
            <Typography variant="body2">Tip</Typography>
          </Box>
          <Button variant="outlined" sx={{ alignSelf: 'flex-end' }}>
            Learn More
          </Button>
        </Stack>
      </UIItemContentContainer>
    </UIShadowContainer>
  )
}
